import { render, staticRenderFns } from "./copy-me.vue?vue&type=template&id=2ecaae7d"
import script from "./copy-me.vue?vue&type=script&lang=js"
export * from "./copy-me.vue?vue&type=script&lang=js"
import style0 from "./copy-me.vue?vue&type=style&index=0&id=2ecaae7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports